import useNotesStore from "@/store/NotesStore"
import { RiDeleteBinFill } from "react-icons/ri"

function NotesWidget() {

  const notes = useNotesStore(state => state.notes)
  const deleteNote = useNotesStore(state => state.deleteNote)

  return (
    <div onContextMenu={(e) => e.preventDefault()} className="space-y-1 rounded-md overflow-hidden bg-zinc-200/70 dark:bg-zinc-800/70">
      {notes.length > 0 ? notes.map(({ id, content }) => (
        <div className="w-full group flex justify-between items-center py-2 px-3 bg-zinc-200/70 dark:bg-zinc-800/70" key={id}>
          <p>{content}</p>
          <button onClick={() => deleteNote(id)} className="opacity-0 group-hover:opacity-100 text-zinc-600 dark:text-zinc-400 hover:text-red-600 dark:hover:text-red-500">
            <RiDeleteBinFill />
          </button>
        </div>
      ))
        : (
          <div className="flex flex-col items-center justify-center h-40">
            <p className="text-zinc-700 dark:text-zinc-300">No notes yet</p>
          </div>
        )
      }
    </div>
  )
}

export default NotesWidget